import axiosInstance from "../instance/axiosInstance";

class SalesInvoiceApi {
  static async fetchSalesInvoiceList(page, searchQuery) {
    let url = `/invoices/list?page=${page}`;
    if (searchQuery) {
      url += `&search_value=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async createSalesInvoice(data) {
    try {
      const response = await axiosInstance.post("/invoices/save", data);
      if (response) return response?.data;
    } catch (error) {
      return error;
    }
  }
  static async deleteInvoice(id) {
    try {
      const response = await axiosInstance.get(`/invoices/delete/${id}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async viewInvoice(id) {
    try {
      const response = await axiosInstance.get(`/invoices/view/${id}`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async viewInvoiceDetail(id) {
    try {
      const response = await axiosInstance.get(`/invoice-view/${id}`);
      console.log('response : ', response);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
  static async checkInvoiceLimit() {
    try {
      const response = await axiosInstance.get(`/invoices/limit-check`);
      if (response) return response.data;
    } catch (error) {
      return error;
    }
  }
}
export default SalesInvoiceApi;
